import React from "react";
import BasicCustomField from "../BasicCustomField";
import { Selection } from "../../../../../../src/application/Contracts";
import MatchingQuantityModel = Selection.MatchingQuantityModel;
import formModelStore from "../../../../../store/FormModelStore";
import getTankMaterialsName = Selection.getTankMaterialsName;
import TankMaterials = Selection.TankMaterials;

export default class TwsMatchingTankQuantity extends BasicCustomField {

    state = {
        value: this.props.value,
        additionalModel: this.props.additionalModel,
    }
    onChangeInput = (matchingQuantity: MatchingQuantityModel) => {
        this.setState({
            value: matchingQuantity.ref
        })
        this.onChange(matchingQuantity);
    }
    renderRow = (matchingQuantity: MatchingQuantityModel) => {
        return <tr key={matchingQuantity.ref}>
            <td>
                <div className={`table-radio-button`}>
                    <input id={`matching-tank-quantity-model-${matchingQuantity.ref}`} type={"radio"}
                        checked={this.checkedRow(matchingQuantity.ref)}
                        name={`matching-tank-quantity-model`}
                        onChange={() => this.onChangeInput(matchingQuantity)} />
                    <label htmlFor={`matching-tank-quantity-model-${matchingQuantity.ref}`}></label>
                </div>
            </td>
            <td>{matchingQuantity.tankVolume}</td>
            <td>{matchingQuantity.madeOfNX}</td>
            <td>{matchingQuantity.unitVolL}</td>
        </tr>
    }

    checkedRow = (row: number) => {
        return formModelStore.formModel?.tankSelection?.selectedMatchingTankQuantity?.value?.ref === row;
    }
    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No matching tank quantities')}</div>
    }

    render() {
        if ((this.props.additionalModel as MatchingQuantityModel[]).length === 0) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <table className={`step-stripped-table data-only`}>
                <thead>
                    <tr>
                        <th></th>
                        <th>{__('Total volume')}</th>
                        <th>{__('Quantity')}</th>
                        <th>{__('Unit Vol (L)')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(this.props.additionalModel as MatchingQuantityModel[]).map(matchingQuantity => this.renderRow(matchingQuantity))}
                </tbody>
            </table>
        </React.Fragment>
    }
}